import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import PatternQuizGame from '../PatternQuizGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day5({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage5 = themeData?.stages_data?.stage_5;
  const questions = stage5?.questions;
  const badgeUrl = s3PublicUrl(stage5?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const hasValidQuestions =
    Array.isArray(questions) &&
    questions.length > 0 &&
    questions.some(
      (q) =>
        String(q?.question ?? '').trim().length > 0 &&
        String(q?.answer ?? '').trim().length > 0
    );
  const isConfigured = !!stage5 && hasValidQuestions;

  return (
    <DayPageShell dayNumber={5} className="main-day-view--immersive">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Stage is not configured: add question and answer entries in stage_5
          questions in the theme.
        </p>
      ) : (
        <PatternQuizGame
          questions={questions}
          rules={stage5.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage5?.title ?? stage5?.name ?? 'Day 5')}
          questionImage={String(stage5?.question_image ?? '')}
          didYouKnowImage={String(stage5?.did_you_know_image ?? '')}
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 5"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
